import { render, staticRenderFns } from "./TwProcessGroupListInfinite.vue?vue&type=template&id=2817536e&scoped=true&"
import script from "./TwProcessGroupListInfinite.vue?vue&type=script&lang=js&"
export * from "./TwProcessGroupListInfinite.vue?vue&type=script&lang=js&"
import style0 from "./TwProcessGroupListInfinite.vue?vue&type=style&index=0&id=2817536e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2817536e",
  null
  
)

export default component.exports